import styles from './SettingsButton.module.css'

interface SettingsButtonProps {
    caption: string
    onClick: (event: any) => void
    ref?: any
}

export const SettingsButton = (props: SettingsButtonProps): JSX.Element => {
    const {
        caption,
        ref,
        onClick
    } = props

    const handleButtonClick = (event: any) => {
        onClick?.(event)
    }

    return (
        <button
            className={styles.SettingsButton}
            onClick={handleButtonClick}
            ref={ref}
        >
            <span
                className={styles.SettingsButton__Caption}
            >
                {caption}
            </span>
        </button>
    )
}